__turbopack_context__.v({
  "boxContainer": "CategoryNavItem-module-scss-module__uk_wQG__boxContainer",
  "cardLink": "CategoryNavItem-module-scss-module__uk_wQG__cardLink",
  "copy": "CategoryNavItem-module-scss-module__uk_wQG__copy",
  "ctaButton": "CategoryNavItem-module-scss-module__uk_wQG__ctaButton",
  "heading": "CategoryNavItem-module-scss-module__uk_wQG__heading",
  "imageContainer": "CategoryNavItem-module-scss-module__uk_wQG__imageContainer",
  "noCta": "CategoryNavItem-module-scss-module__uk_wQG__noCta",
});
